import { useQuery } from '@tanstack/react-query'
import { fetchAllTabs, fetchSubBySlug } from '../../app/services/strapiServices'
import { atomWithQuery } from 'jotai-tanstack-query'
import { GuideMainTab, GuideSubTab, SubTab } from '@app/components/Guide/types/guide.types'

export const mainTabsAtom = atomWithQuery<GuideMainTab[]>((_get) => ({
  queryKey: ['main-tabs'],
  queryFn: fetchAllTabs,
}))

export const useSubTabBySlug = (subTabSlug: GuideSubTab['slug']) => {
  return useQuery<SubTab>({
    queryKey: ['sub-tab-content-by-slug', subTabSlug],
    queryFn: () => fetchSubBySlug(subTabSlug),
    enabled: !!subTabSlug,
  })
}
